export default __webpack_public_path__ + "static/media/thumbnail_blog_17.c082be1f.png";